export default function AccountIcon({ className }: { className?: string }) {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M8.83333 4.20894C8.83333 4.66918 8.46024 5.04227 8 5.04227C7.53976 5.04227 7.16667 4.66918 7.16667 4.20894C7.16667 3.7487 7.53976 3.37561 8 3.37561C8.46024 3.37561 8.83333 3.7487 8.83333 4.20894ZM8.85964 0.937531C8.34748 0.563792 7.65252 0.563791 7.14036 0.937531L0.955475 5.45082C0.141239 6.045 0.561518 7.33394 1.5695 7.33394H1.75L1.75 12.1672C1.00798 12.5465 0.5 13.3184 0.5 14.2089V15.4589C0.5 15.8041 0.779822 16.0839 1.125 16.0839H14.875C15.2202 16.0839 15.5 15.8041 15.5 15.4589V14.2089C15.5 13.3184 14.992 12.5465 14.25 12.1672V7.33394H14.4305C15.4385 7.33394 15.8588 6.045 15.0445 5.45082L8.85964 0.937531ZM7.87719 1.94727C7.95036 1.89388 8.04964 1.89388 8.12281 1.94727L13.7916 6.08394H2.20842L7.87719 1.94727ZM13 7.33394V11.9173H11.3333V7.33394H13ZM10.0833 7.33394V11.9173H8.625V7.33394H10.0833ZM7.375 7.33394V11.9173H5.91667L5.91667 7.33394H7.375ZM2.79167 13.1673H13.2083C13.7836 13.1673 14.25 13.6336 14.25 14.2089V14.8339H1.75V14.2089C1.75 13.6336 2.21637 13.1673 2.79167 13.1673ZM3 11.9173L3 7.33394H4.66667L4.66667 11.9173H3Z"
        fill="#D1D5DC"
      />
    </svg>
  );
}
